import { render, staticRenderFns } from "./debtor-employee-form.vue?vue&type=template&id=0af54a18&scoped=true&"
import script from "./debtor-employee-form.vue?vue&type=script&lang=js&"
export * from "./debtor-employee-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af54a18",
  null
  
)

export default component.exports